import $ from "jquery";
import Plyr from "plyr";

export default () => {
  $('.js-player').each((index, element) => new Plyr(element))
}
